import { NgModule } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApPanelComponent } from '@ap/panel';
import { ApContentPipe, ApContentService } from '@ap/content';

import { ConversationalChatConnectionerrorComponent } from './conversational-chat-connectionerror/conversational-chat-connectionerror.component';
import { ConversationalChatRetryconnectionerrorComponent } from './conversational-chat-retryconnectionerror/conversational-chat-retryconnectionerror.component';

@NgModule({
    declarations: [ConversationalChatConnectionerrorComponent, ConversationalChatRetryconnectionerrorComponent],
    imports: [ApContentPipe, ApButtonComponent, ApPanelComponent],
    exports: [ConversationalChatConnectionerrorComponent, ConversationalChatRetryconnectionerrorComponent],
    providers: [ApContentService]
})
export class ConversationalChatErrorhandlerModule {}
